<template>
  <div>
    <section class="content">
      <div class="container-fluid">
        <div class="block-header">
          <h2>DASHBOARD</h2>
        </div>

        <!-- Widgets -->
        <div class="row clearfix">
          <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12">
            <div class="info-box bg-light-blue hover-expand-effect">
              <div class="icon">
                <i class="material-icons">person_add</i>
              </div>
              <div class="content">
                <div class="text">REGIS SEKOLAH</div>
                <div
                  class="number count-to"
                  data-from="0"
                  data-to="125"
                  data-speed="15"
                  data-fresh-interval="20"
                >123</div>
              </div>
            </div>
          </div>

          <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12">
            <div class="info-box bg-cyan hover-expand-effect">
              <div class="icon">
                <i class="material-icons">assignment_returned</i>
              </div>
              <div class="content">
                <div class="text">QUESTIONER PENDING</div>
                <div
                  class="number count-to"
                  data-from="0"
                  data-to="257"
                  data-speed="1000"
                  data-fresh-interval="20"
                >1</div>
              </div>
            </div>
          </div>

          <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12">
            <div class="info-box bg-light-green hover-expand-effect">
              <div class="icon">
                <i class="material-icons">assignment_turned_in</i>
              </div>
              <div class="content">
                <div class="text">QUESTIONER APPROVED</div>
                <div
                  class="number count-to"
                  data-from="0"
                  data-to="243"
                  data-speed="1000"
                  data-fresh-interval="20"
                >1</div>
              </div>
            </div>
          </div>

          <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12">
            <div class="info-box bg-orange hover-expand-effect">
              <div class="icon">
                <i class="material-icons">assignment_late</i>
              </div>
              <div class="content">
                <div class="text">QUESTIONER REJECTED</div>
                <div
                  class="number count-to"
                  data-from="0"
                  data-to="1225"
                  data-speed="1000"
                  data-fresh-interval="20"
                >0</div>
              </div>
            </div>
          </div>
        </div>
        <!-- #END# Widgets -->
        <div class="row">
          <div class="col-md-6">
            <div class="card">
              <div class="header">
                <h5>PRESENTASE JENIS QUESTIONER</h5>
              </div>
              <div class="body">
                <iframe class="chartjs-hidden-iframe" style="width: 100%; display: block; border: 0px; height: 0px; margin: 0px; position: absolute; left: 0px; right: 0px; top: 0px; bottom: 0px;"></iframe>
                <canvas id="presentase_questioner" width="400" height="250"></canvas>
              </div>
            </div>
          </div>

          <div class="col-md-6">
            <div class="card">
              <div class="header">
                <h5>PRESENTASE INPUT QUESTIONER</h5>
              </div>
              <div class="body">
                <iframe class="chartjs-hidden-iframe" style="width: 100%; display: block; border: 0px; height: 0px; margin: 0px; position: absolute; left: 0px; right: 0px; top: 0px; bottom: 0px;"></iframe>
                <canvas id="presentase_input_questioner" width="400" height="250"></canvas>
              </div>
            </div>
          </div>

          <div class="col-md-12">
            <div class="card">
              <div class="header">
                <h5>KEPEMILIKAN JUKLAK/JUKNIS</h5>
              </div>
              <div class="body">
                <iframe class="chartjs-hidden-iframe" style="width: 100%; display: block; border: 0px; height: 0px; margin: 0px; position: absolute; left: 0px; right: 0px; top: 0px; bottom: 0px;"></iframe>
                <canvas id="kepemilikan_juklak_juknis" width="400" height="200%"></canvas>
              </div>
            </div>
          </div>

        </div>
      </div>
    </section>
  </div>
</template>

<script>
import Chart from "chart.js";

import io from "socket.io-client";

export default {
  data() {
    return {
      user: "",
      message: "",
      messages: [],
      socket: io("http://localhost:5000")
    };
  },
  methods: {
    sendMessage(e) {
      e.preventDefault();

      this.socket.emit("SEND_MESSAGE", {
        user: this.user,
        message: this.message
      });
      this.message = "";
    },
// ========================================== CHART ===========================================
    kepemilikan_juklak_juknis: function() {
      var ctx = document.getElementById("kepemilikan_juklak_juknis").getContext("2d");

      var myChart = new Chart(ctx, {
        type: "bar",
        data: {
        labels: ["Kendari", "Bau-bau", "Wakatobi", "Muna", "Mubar", "Konut", "Konsel", "Konkep", "Konawe", "Kolut", "Koltim", "Kolaka","Butur","Buteng", "Busel","Buton", "Bombana"],
        datasets: [{
            label: "My First dataset",
            data: [12, 11, 20, 11, 8, 22, 24, 23, 6, 10, 12,15, 15, 16,11, 13, 9],
            borderColor: 'rgba(0, 188, 212, 0.8)',
            backgroundColor: 'rgba(0, 188, 212, 0.5)',
            pointBorderColor: 'rgba(0, 188, 212, 0)',
            pointBackgroundColor: 'rgba(0, 188, 212, 0.8)',
            pointBorderWidth: 1
        }, {
                label: "My Second dataset",
                data: [11, 15, 8, 13, 21, 6, 9, 6, 19, 14, 11,12, 11, 9,15, 11, 20],
                borderColor: 'rgba(233, 30, 99, 0.8)',
                backgroundColor: 'rgba(233, 30, 99, 0.5)',
                pointBorderColor: 'rgba(233, 30, 99, 0)',
                pointBackgroundColor: 'rgba(233, 30, 99, 0.8)',
                pointBorderWidth: 1
            }]
        },
        options: {
            responsive: true,
            legend: false
        }
      });
    },

    presentase_input_questioner: function() {
        var ctx = document.getElementById("presentase_input_questioner").getContext("2d");

        var myChart = new Chart(ctx, {
        type: 'doughnut',
        data: {
            datasets: [{
                data: [225, 50, 100],
                backgroundColor: [
                    // "rgb(233, 30, 99)",
                    "rgb(255, 193, 7)",
                    "rgb(0, 188, 212)",
                    "rgb(139, 195, 74)"
                ],
            }],
            labels: [
                "Pending",
                "Diterima",
                "Dikoreksi",
                // "Light Green"
            ]
        },
        options: {
            responsive: true,
            legend: false
        }
      });
    },

    presentase_questioner: function() {
      var ctx = document.getElementById("presentase_questioner").getContext("2d");

      var myChart = new Chart(ctx, {
        type: 'pie',
        data: {
            datasets: [{
                data: [225, 50, 100, 40],
                backgroundColor: [
                    "rgb(233, 30, 99)",
                    "rgb(255, 193, 7)",
                    "rgb(0, 188, 212)",
                    "rgb(139, 195, 74)"
                ],
            }],
            labels: [
                "Instrumen KS-Bendahara",
                "Instrumen Komite Sekolah",
                "Instrumen Guru",
                "Instrumen Verifikasi Dapodik"
            ]
        },
        options: {
            responsive: true,
            legend: false
        }
      });
    }


// ========================================== CHART ===========================================

  },
  mounted() {
    localStorage.sidemenu = 'bhumie';
    this.kepemilikan_juklak_juknis();
    this.presentase_questioner();
    this.presentase_input_questioner();

    this.socket.on("MESSAGE", data => {
      console.log(data);
      this.messages = data;
      // you can also do this.messages.push(data)
    });
  }
};
</script>
